import { useLayoutEffect } from 'react';
import ToolsApp from './components/App.jsx';
import { AppProvider } from './js/context.js';
import initImports from './js/modulesLoader.js';
import './_style.scss';
import ReactGA from "react-ga4";

ReactGA.initialize('G-J6Z3YN2X7Z');

const App = () => {
	useLayoutEffect(() => {
		initImports();
		
	}, []);

	return (
		<AppProvider>
			<ToolsApp />
		</AppProvider>
	);
};

export default App;
